const PlaygroundTabs = {
  ABOUT: "about",
  EXAMPLES: "examples",
  LIVE_CHAT: "live-chat",
  CONNECT: "connect",
};

export default PlaygroundTabs;
